import { render, staticRenderFns } from "./textHighlight.vue?vue&type=template&id=43244620&"
import script from "./textHighlight.vue?vue&type=script&lang=js&"
export * from "./textHighlight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports